import { Button, Input, Radio, Switch } from 'antd';
import { ToastSuccess } from 'components/Toaster';
import { ComponentArrasteSolteService } from 'core/http/service/componetInteraction/ComponentArrasteSolte.service';
import { ComponentGameMemoryService } from 'core/http/service/componetInteraction/ComponentGameMemory.service';

import Colors from 'enums/Colors';
import { isArray } from 'lodash';

import ComponentGameMemory from 'models/componentInteraction/ComponentGameMemory';
import ComponentGameMemoryCard from 'models/componentInteraction/ComponentGameMemoryCard';

import React, { useEffect, useRef, useState } from 'react';

import { MdAdd, MdDeleteForever, MdKeyboardArrowLeft, MdKeyboardArrowRight, MdSaveAs } from 'react-icons/md';
import styled from 'styled-components';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        max-width: 1280px;
        gap: 1rem;
    `,

    Grid: styled.div`
        display: grid;
        grid-template-columns: 140px 140px 140px 140px;
    `,

    Row: styled.div`
        display: flex;
    `,

    RowEnd: styled.div`
        display: flex;
        align-items: center;
        justify-content: end;
        width: 100%;
        gap: 1rem;
    `,

    RowBetween: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,

    Title: styled.h1`
        font-family: 'Barlow';
        font-size: 18px;
        font-weight: 600;
        line-height: 25.2px;
        text-align: left;
        text-decoration-skip-ink: none;
        color: ${Colors.Blue};
    `,

    SubTitle: styled.h2`
        font-family: 'Barlow';
        font-size: 14px;
        font-weight: 600;
        line-height: 19.6px;
        text-align: left;
        text-decoration-skip-ink: none;
    `,

    Preview: styled.div<{ isPreview: boolean }>`
        border: 1px solid ${Colors.Blue};
        width: 60px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        background-color: ${({ isPreview }) => (isPreview ? Colors.Blue : Colors.White)};
        cursor: pointer;
    `,

    Column: styled.div`
        display: flex;
        width: 100%;
        gap: 0.5rem;
        flex-direction: column;
    `,

    Regua: {
        Container: styled.div``,
    },

    Options: {
        Container: styled.div`
            display: flex;
            align-items: center;
            gap: 1rem;
            height: 52px;
        `,

        NumberPosition: styled.div`
            width: 50px;
            height: 50px;
            padding: 15px 21px 15px 21px;
            gap: 16px;
            border-radius: 5px;
            border: 1px 0px 0px 0px;
            opacity: 0px;
            border: 1px solid #e6e6e6;
            background: #f9f9f9;
        `,
    },

    Navigation: {
        Arrow: styled.div`
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            margin-right: 10px;
            width: 62px;
            border-radius: 5px;
            border: 1px solid #e6e6e6;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
                border: 1px solid ${Colors.Blue};
            }
        `,

        ItemFooter: styled.div<{ isActive: boolean }>`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 4px;
            align-items: center;
            justify-content: center;
            border: 1px solid ${Colors.Blue};
            color: ${({ isActive }) => (isActive ? Colors.White : Colors.Blue)};
            background-color: ${({ isActive }) => (isActive ? Colors.Blue : Colors.White)};
            cursor: pointer;
        `,
    },

    Feedback: {
        Container: styled.div`
            display: flex;
            gap: 1rem;
            height: 133px;
            width: 100%;
        `,
    },

    Button: styled.button`
        width: 38px;
        height: 38px;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid ${Colors.Grey11};
        margin-left: 10px;
    `,

    Card: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 140px;
        height: 140px;
        border-radius: 8px;
        border: 1px solid ${Colors.Grey12};
        cursor: pointer;

        color: ${Colors.Grey12};
    `,
};

interface IComponentGameMemoryAdmin {
    dados: ComponentGameMemory[] | null;
    codigoInteraction: number;
}

//services
const service = new ComponentGameMemoryService();

const ComponentGameMemoryAdmin = ({ dados, codigoInteraction }: IComponentGameMemoryAdmin) => {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [gameMemory, setGameMemory] = useState<ComponentGameMemory[] | null>(dados);
    const [indexGameMemory, setIndexGameMomory] = useState<number>(0);
    const [quantityGameMemory, setQuantityGameMomory] = useState<number>(dados?.length ?? 1);
    const [indexCardClick, setIndexCardClick] = useState<number>(-1);

    //loadings
    const [loadingSave, setLoadingSave] = useState<boolean>(false);

    const handleSave = async () => {
        if (gameMemory) {
            setLoadingSave(true);

            const { data, status } = await service.saveGameOne(gameMemory[indexGameMemory], codigoInteraction);
            if (status === 201) {
                ToastSuccess('Componente salvo com sucesso!');

                setGameMemory((prev: any) =>
                    prev.map((game: ComponentGameMemory, index: number) => {
                        if (index === indexGameMemory) {
                            game = data;
                        }

                        return game;
                    })
                );
            }

            setLoadingSave(false);
        }
    };

    const handleNewCard = (index: number) => {
        const card = new ComponentGameMemoryCard().fromJSON({
            codigo: -1,
            filepath: '',
            base64: '',
            relationCardNumber: -1,
        });

        if (gameMemory) {
            const cards = [...gameMemory[index].cards, card];

            setGameMemory((prev: any) =>
                prev.map((game: ComponentGameMemory, i: number) => {
                    if (i === index) {
                        game.cards = cards;
                    }

                    return game;
                })
            );
        }
    };
    const handleNewGame = async () => {
        const newGame = new ComponentGameMemory().fromJSON({
            codigo: -1,
            title: '',
            haveTime: false,
            cards: [],
        });

        if (isArray(gameMemory)) {
            const { data, status } = await service.saveGameOne(newGame, codigoInteraction);

            if (status === 201) {
                ToastSuccess('Novo jogo da memória criado com sucesso!');
                setGameMemory((prev: any) => [...prev, data]);
                setIndexGameMomory(indexGameMemory + 1);
                setQuantityGameMomory(quantityGameMemory + 1);
            }
        }
    };

    const removeCard = async (indexGame: number, indexCard: number) => {
        if (gameMemory && gameMemory[indexGame].cards) {
            const idCard = gameMemory[indexGame].cards.filter((_, i) => i === indexCard)[0].codigo;
            const cardsAtualizados = gameMemory[indexGame].cards.filter((_, i) => i !== indexCard);

            if (idCard != -1) {
                await service.deleteCard(idCard);
            }
            setGameMemory((prev: any) =>
                prev.map((game: ComponentGameMemory, index: number) => {
                    if (index === indexGame) {
                        game.cards = cardsAtualizados;
                    }

                    return game;
                })
            );
        }
    };

    const removeGame = async () => {
        if (gameMemory) {
            const idGame = gameMemory[indexGameMemory].codigo;

            if (idGame && idGame !== -1) {
                const { status } = await service.deleteGame(idGame);
                if (status === 204) {
                    ToastSuccess('Jogo removido com sucesso!');
                }
            }
            // Filtra a lista de quizzes para remover o quiz no indexArraste
            const listAtt = gameMemory.filter((_, i) => indexGameMemory !== i);
            // Atualiza o índice, se necessário
            const newIndexGame = indexGameMemory > 0 ? indexGameMemory - 1 : 0; // Garante que não vá para um índice negativo
            setIndexGameMomory(newIndexGame);
            setQuantityGameMomory(quantityGameMemory - 1);
            // Atualiza o estado com a nova lista de quizzes
            setGameMemory(listAtt);
        }
    };

    const handleFrontImageChange = (event: React.ChangeEvent<HTMLInputElement>, indexGame: number, indexCard: number) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setGameMemory((prev: any) =>
                    prev.map((game: ComponentGameMemory, iGame: number) => {
                        if (indexGame === iGame) {
                            game.cards[indexCardClick].base64 = reader.result as string;
                        }

                        return game;
                    })
                );
            };
            reader.readAsDataURL(file);
        }
    };

    return (
        <Styled.Container>
            <Styled.Title>Jogo da memória</Styled.Title>
            {gameMemory &&
                gameMemory.length > 0 &&
                gameMemory.map((game, indexGame) => (
                    <>
                        {indexGame === indexGameMemory && (
                            <React.Fragment key={indexGame}>
                                <Styled.RowBetween style={{ gap: '2rem' }}>
                                    <Input
                                        size="large"
                                        placeholder="Digite o título"
                                        showCount
                                        maxLength={200}
                                        onChange={e =>
                                            setGameMemory((prev: any) =>
                                                prev.map((p: ComponentGameMemory, indexGame: number) => {
                                                    if (indexGame === indexGameMemory) {
                                                        p.title = e.target.value;
                                                    }

                                                    return {
                                                        ...p,
                                                    };
                                                })
                                            )
                                        }
                                        value={gameMemory[indexGameMemory]?.title}
                                    />
                                    <Styled.Column style={{ width: '100px' }}>
                                        <Styled.SubTitle>Mostrar tempo gasto</Styled.SubTitle>
                                        <Switch
                                            style={{ width: '60px' }}
                                            value={game.haveTime}
                                            onChange={check =>
                                                setGameMemory((prev: any) =>
                                                    prev.map((g: ComponentGameMemory, i: number) => {
                                                        if (i === indexGame) {
                                                            g.haveTime = check;
                                                        }

                                                        return g;
                                                    })
                                                )
                                            }
                                        />
                                    </Styled.Column>
                                </Styled.RowBetween>
                                <Styled.Grid style={{ width: '100%', gap: '1rem' }}>
                                    {isArray(game.cards) &&
                                        game.cards.length > 0 &&
                                        game.cards.map((card, index) => (
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }} key={index}>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={e => handleFrontImageChange(e, indexGameMemory, index)}
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }} // Oculta o input
                                                />
                                                <Styled.Card
                                                    key={index}
                                                    onClick={() => {
                                                        setIndexCardClick(index);
                                                        fileInputRef.current?.click();
                                                    }}
                                                >
                                                    {card.base64 != null && card.base64.length > 0 ? (
                                                        <img
                                                            src={card.base64}
                                                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                                                        />
                                                    ) : (
                                                        <p>Adicionar uma imagem</p>
                                                    )}
                                                </Styled.Card>
                                                <Button
                                                    size="large"
                                                    style={{ color: Colors.DeleteRed }}
                                                    onClick={() => removeCard(indexGame, index)}
                                                >
                                                    <MdDeleteForever /> Remover cartão
                                                </Button>
                                            </div>
                                        ))}
                                </Styled.Grid>

                                <Styled.RowBetween style={{ gap: '1rem' }}>
                                    <div style={{ display: 'flex', gap: '1rem' }}>
                                        <Button size="large" style={{ width: 200 }} onClick={() => handleNewCard(indexGameMemory)}>
                                            <MdAdd /> Novo cartão
                                        </Button>
                                        <Button size="large" style={{ width: 200 }} onClick={handleNewGame}>
                                            <MdAdd /> Novo jogo
                                        </Button>
                                    </div>

                                    <Button size="large" style={{ width: 200 }} onClick={handleSave} loading={loadingSave}>
                                        <MdSaveAs /> Salvar jogo
                                    </Button>
                                    {indexGame != 0 && (
                                        <Button size="large" style={{ width: 200, color: Colors.DeleteRed }} onClick={removeGame}>
                                            <MdDeleteForever /> Remover jogo
                                        </Button>
                                    )}

                                    <Styled.RowEnd style={{ width: 'fit-content' }}>
                                        <p>Navegue entre os jogos de memória:</p>
                                        {Array.from({ length: quantityGameMemory }).map((_, index) => (
                                            <Styled.Navigation.ItemFooter
                                                onClick={() => setIndexGameMomory(index)}
                                                isActive={indexGameMemory == index}
                                                key={index}
                                            >
                                                {index + 1}
                                            </Styled.Navigation.ItemFooter>
                                        ))}
                                    </Styled.RowEnd>
                                </Styled.RowBetween>
                            </React.Fragment>
                        )}
                    </>
                ))}
        </Styled.Container>
    );
};

export default ComponentGameMemoryAdmin;
